import React from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { getApiUrl } from '../../../../utils/Env';
import { DeleteIcon, DownloadIconLine } from '../../../../utils/SVGIcon';
import { GetDateTime, GetFileSize } from '../../../../utils/Show';
import cn from '../../../../utils/cn';
import { ApiLogsFilesDeleteOpe } from '../LogFilesListOperation';

function TableRow({ item, handleReload }) {
    const { setConfirm, setMessage } = useTemplate();
    const handleDeleteModalShow = (name) => {
        setConfirm({
            text: 'Are you sure you want to delete this log file?',
            textAction: 'Yes, Delete',
            clickAction: () => {
                ApiLogsFilesDeleteOpe(name)
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        handleReload();
                    })
                    .catch((err) => {
                        setMessage({ type: 'error', text: err.toString(0) });
                    });
            }
        });
    };
    return (
        <tr className={cn(`group hover:!bg-secondary-50`, { 'placeholder-mode': item?.demo })}>
            <td className="!pl-5">
                <span>{item?.name}</span>
            </td>
            <td className="text-center">
                <span>{GetFileSize(item?.size)}</span>
            </td>
            <td>
                <span>{GetDateTime(item?.created)}</span>
            </td>
            <td>
                <div className="inline-flex items-center justify-center gap-2">
                    <a
                        href={`${getApiUrl()}/api/logs/file/download/${item?.name}`}
                        target="_blank"
                        className="inline-block text-secondary size-8 bg-primary-50 hover:bg-secondary hover:text-white transition-colors rounded-5 p-1.5"
                        rel="noreferrer"
                    >
                        <DownloadIconLine />
                    </a>
                    <span>
                        <button
                            type="button"
                            onClick={() => handleDeleteModalShow(item?.name)}
                            className="size-8 bg-error/20 text-error p-1.5 rounded-5 hover:bg-error hover:text-white transition-colors"
                        >
                            <DeleteIcon />
                        </button>
                    </span>
                </div>
            </td>
        </tr>
    );
}
function TableHeader() {
    return (
        <thead>
            <tr>
                <th scope="col" className="!w-auto">
                    <span>Name</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Log Size</span>
                </th>
                <th scope="col" className="w-42 text-center">
                    <span>Log Date & Time</span>
                </th>
                <th scope="col" className="!w-38">
                    <span>Action</span>
                </th>
            </tr>
        </thead>
    );
}

function LogsFilesPageTable({ data, handleReload }) {
    return (
        <div className="logs_page_table">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody>
                    {data && data?.length === 0 ? (
                        <tr className="border-b border-[#1B1B1F]/10 h-12.5">
                            <td colSpan={4} className="!text-left">
                                <span className="text-primary-700 ">No Logs Found!</span>
                            </td>
                        </tr>
                    ) : (
                        data?.map((item) => (
                            <TableRow key={item?.name} item={item} handleReload={handleReload} />
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default LogsFilesPageTable;
